module.exports = __webpack_public_path__ + "img/cerrar-sesion.ed32445a.svg";